import type React from "react";
import { ReactComponent as Svg } from "./assets/won.svg";
import * as styles from "./Icon.module.scss";

type WonProps = React.SVGProps<SVGSVGElement>;

export const Won = ({ className, ...props }: WonProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
